import dateFormatType from '@/constants/dateFormatType';
import brgI18n from '@/locales';
import { numberToFormatted, validateTextWithHypen, } from '@/utils';
import { format } from 'date-fns';
export class WorkerMonthlyAttendanceDailyData {
    _dayData;
    constructor(dayData) {
        this._dayData = dayData;
    }
    /** 출근 */
    get formattedStartWorkedAt() {
        const startWorkedAt = this._dayData?.startWorkedAt;
        if (!startWorkedAt) {
            return validateTextWithHypen(startWorkedAt);
        }
        const formattedStartWorkedAt = format(new Date(startWorkedAt), dateFormatType.SHORT_TIME);
        return validateTextWithHypen(formattedStartWorkedAt);
    }
    /** 퇴근 */
    get formattedEndWorkedAt() {
        const endWorkedAt = this._dayData?.endWorkedAt;
        if (!endWorkedAt) {
            return validateTextWithHypen(endWorkedAt);
        }
        const formattedEndWorkedAt = format(new Date(endWorkedAt), dateFormatType.SHORT_TIME);
        return validateTextWithHypen(formattedEndWorkedAt);
    }
    /** 전체완료 */
    get formattedTotalDeliveryCount() {
        const totalDeliveryCount = this._dayData?.totalDeliveryCount;
        if (!totalDeliveryCount) {
            return validateTextWithHypen(totalDeliveryCount);
        }
        const totalDeliveryCountWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(totalDeliveryCount),
        });
        return validateTextWithHypen(totalDeliveryCountWithSuffix);
    }
    /** 전체근무시간(분) - 시간 */
    get formattedWorkingTime() {
        const workingTime = this._dayData?.workingTime;
        if (!workingTime) {
            return validateTextWithHypen(workingTime);
        }
        const oneHour = 60;
        const hour = Math.floor(workingTime / oneHour);
        const minuete = workingTime % oneHour;
        const hourText = hour.toString().padStart(2, '0');
        const minText = minuete.toString().padStart(2, '0');
        return `${hourText}:${minText}`;
    }
    /** 전체근무시간(분) - 분 */
    get formattedWorkingMinuete() {
        const workingTime = this._dayData?.workingTime;
        if (!workingTime) {
            return validateTextWithHypen(workingTime);
        }
        const workingTimeWithSuffix = brgI18n.global.t('common.minutes_suffix', {
            minutes: numberToFormatted(workingTime),
        });
        return validateTextWithHypen(workingTimeWithSuffix);
    }
    /** 시간범위완료 */
    get formattedTotalDeliveryCountInPeriod() {
        const totalDeliveryCountInPeriod = this._dayData?.totalDeliveryCountInPeriod;
        if (!totalDeliveryCountInPeriod) {
            return validateTextWithHypen(totalDeliveryCountInPeriod);
        }
        const totalDeliveryCountInPeriodWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(totalDeliveryCountInPeriod),
        });
        return validateTextWithHypen(totalDeliveryCountInPeriodWithSuffix);
    }
    /** 시간범위근무시간(분) - 시간 */
    get formattedWorkingTimeInPeriod() {
        const workingTimeInPeriod = this._dayData?.workingTimeInPeriod;
        if (!workingTimeInPeriod) {
            return validateTextWithHypen(workingTimeInPeriod);
        }
        const oneHour = 60;
        const hour = Math.floor(workingTimeInPeriod / oneHour);
        const minuete = workingTimeInPeriod % oneHour;
        const hourText = hour.toString().padStart(2, '0');
        const minText = minuete.toString().padStart(2, '0');
        return `${hourText}:${minText}`;
    }
    /** 시간범위근무시간(분) - 분 */
    get formattedWorkingMinueteInPeriod() {
        const workingTimeInPeriod = this._dayData?.workingTimeInPeriod;
        if (!workingTimeInPeriod) {
            return validateTextWithHypen(workingTimeInPeriod);
        }
        const workingTimeInPeriodWithSuffix = brgI18n.global.t('common.minutes_suffix', {
            minutes: numberToFormatted(workingTimeInPeriod),
        });
        return validateTextWithHypen(workingTimeInPeriodWithSuffix);
    }
}
